// src/pages/reports/PaymentsReport.jsx
import BaseReportPage from '../../components/reports/BaseReportPage'
import PaymentsFilters from '../../components/reports/PaymentsFilters'

const PaymentsReport = () => {
  const columns = [
    { key: 'date', label: 'Date', type: 'date' },
    { key: 'orderNumber', label: 'Order No', type: 'text' },
    { key: 'customer', label: 'Customer', type: 'text' },
    { key: 'orderType', label: 'Order Type', type: 'text' },
    { key: 'totalBill', label: 'Total Bill', type: 'currency' },
    { key: 'paymentType', label: 'Payment Type', type: 'text' },
  ]

  return (
    <BaseReportPage
      reportType="payments"
      title="Payments Report"
      columns={columns}
      dataKey="data"
      enableFilters={true}
      customFilterComponent={PaymentsFilters}
    />
  )
}

export default PaymentsReport